import React from "react";
import mantisLogo from "../../Assets/img/icons/b2b/mantisBlack.png";
import "./styles/pageHeader.scss";

function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="mantis-page-banner">
      <div className="banner-content">
        <div className="banner-heading">
          <img src={mantisLogo} alt="Mantis" className="banner-logo" />
          <div className="banner-text">
            <h1 className="banner-title">{title}</h1>
            {subtitle && <p className="banner-subtitle">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="banner-actions">{actions}</div>}
      </div>
    </div>
  );
}

export default PageHeader;
